import settingAPI from '@/api/setting';
import {
  GET_DEPARTMENT_LIST,
  GET_DEPARTMENTS,
  CREATE_DEPARTMENT,
  REMOVE_DEPARTMENT,
  GET_TEAM_INFO,
  UPDATE_TEAM_INFO,
  UPDATE_DEPARTMENT_INFO,
  CONTACT,
  UPGRADE,
} from './constants';

export default {
  async [GET_DEPARTMENT_LIST]() {
    const { departments } = await settingAPI.getDepartmentList();
    return departments;
  },
  async [GET_DEPARTMENTS]() {
    const { departments } = await settingAPI.getDepartments();
    return departments;
  },
  async [CREATE_DEPARTMENT](ctx, payload) {
    const res = await settingAPI.createDepartment(payload);
    return res;
  },
  async [REMOVE_DEPARTMENT](ctx, id) {
    const res = await settingAPI.removeDepartment(id);
    return res;
  },
  async [GET_TEAM_INFO]() {
    const { team } = await settingAPI.getTeamInfo();
    return team;
  },
  async [UPDATE_TEAM_INFO](ctx, payload) {
    const res = await settingAPI.updateTeamInfo(payload);
    return res;
  },
  async [UPDATE_DEPARTMENT_INFO](ctx, payload) {
    const res = await settingAPI.updateDepartmentInfo(payload);
    return res;
  },
  async [CONTACT](ctx, payload) {
    const res = await settingAPI.contact(payload);
    return res;
  },
  async [UPGRADE](ctx, payload) {
    const res = await settingAPI.upgrade(payload);
    return res;
  },
};
